import cx from 'classnames';
import { useContext } from 'react';
import SEOContext from '~/context/srp/SEOContext';
import type { VanityUrl } from '~/contracts/srp';

export function formatKeyWordAndLocation(vanityUrl: VanityUrl): string {
  const location = vanityUrl.location ? `in ${vanityUrl.location}` : '';

  return `Used ${vanityUrl.keyword} ${location}`;
}

type OwnProps = {
  className?: string;
};

export default function TitleTag({ className }: OwnProps) {
  const { vanityUrl } = useContext(SEOContext);

  return vanityUrl == null ? null : (
    <h1
      data-testid="vanity-url-title-tag"
      className={cx(
        className,
        'm-0 w-full truncate bg-background-primary-subtle pl-2xl pt-xl text-text-strong t-heading-xs sm:bg-background-default sm:pb-xl sm:pl-3xl sm:pt-0 md:pl-0'
      )}
    >
      {formatKeyWordAndLocation(vanityUrl)}
    </h1>
  );
}
